<template>
  <div>
    <div class="text-center">
      <h3 class="title-pages color-blue">LANÇAR TRANSFERÊNCIA</h3>
    </div>

    <div class="v-content-card row m-0">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
        <LabelRequiredField label="DE:" />
        <vs-select autocomplete style="width: 100%" v-model="origin_account_id">
          <vs-select-item
            v-for="item in finance_configuration_account"
            :key="item.id"
            :value="item.id"
            :text="
              item.finance_configuration_grouping_description
                ? `${item.finance_configuration_grouping_description} / ${item.account_nickname}`
                : `${item.account_nickname}`
            "
          />
        </vs-select>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
        <LabelRequiredField label="PARA:" />
        <vs-select
          autocomplete
          style="width: 100%"
          v-model="destination_account_id"
        >
          <vs-select-item
            v-for="item in finance_configuration_account"
            :key="item.id"
            :value="item.id"
            :text="
              item.finance_configuration_grouping_description
                ? `${item.finance_configuration_grouping_description} / ${item.account_nickname}`
                : `${item.account_nickname}`
            "
          />
        </vs-select>
      </div>
    </div>

    <div class="v-content-card row m-0">
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12">
        <LabelRequiredField label="QUANDO:" />
        <input type="date" class="form-control" v-model="date" />
      </div>
    </div>

    <div class="v-content-card row m-0">
      <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12">
        <LabelRequiredField label="DESCRIÇÃO:" />
        <input type="text" class="form-control" v-model="description" />
      </div>
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
        <LabelRequiredField label="VALOR:" />
        <input
          type="text"
          class="form-control"
          v-model="value"
          @input="handleInputValue($event.target.value)"
        />
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-8 col-12">
        <label class="upper-text">Centro de custo/lucro</label>
        <vs-select
          autocomplete
          style="width: 100%"
          v-model="finance_configuration_profit_cost_center_id"
        >
          <vs-select-item
            v-for="item in finance_configuration_profit_cost_center"
            :key="item.id"
            :value="item.id"
            :text="item.description"
          />
        </vs-select>
      </div>
    </div>

    <div class="v-content-card">
      <ErrorsMessages :errors="errors" />

      <WarningRequiredFields />
    </div>

    <div class="v-content-card text-right">
      <confirmation-dialog
        headerClass="modal-header-red"
        message-title="CANCELAR?"
        :message-body="`Deseja realmente cancelar o registro de transferência?`"
        open-class="btn-modern btn-modern-delete mr-2"
        yes-class="btn-delete"
        open-text="CANCELAR"
        @yes="handleBack"
      />

      <v-btn
        :disabled="loading"
        @click="create"
        class="btn-modern btn-modern-save"
      >
        <i class="fas fa-check mr-2 text-twenty"></i>
        {{ loading ? "CARREGANDO" : "SALVAR" }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import LabelRequiredField from "../../Components/LabelRequiredField";

import WarningRequiredFields from "../../Components/WarningRequiredFields";

import ConfirmationDialog from "../../Components/ConfirmationDialog";

import moment from "moment";

import {
  formatValueOnKeyUp,
  formatValueNegativeOnKeyUp,
} from "../../../lib/format";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

import { getRestHomeSelectedFinancialAccount } from "../../../lib/functions";

export default {
  name: "Transfer",
  components: {
    ErrorsMessages,
    LabelRequiredField,
    WarningRequiredFields,
    ConfirmationDialog,
  },
  data() {
    return {
      origin_account_id: "",
      destination_account_id: "",
      date: moment().format("YYYY-MM-DD"),
      description: "Transferência entre contas",
      value: "",
      finance_configuration_profit_cost_center_id: "",
      finance_configuration_account: [],
      finance_configuration_profit_cost_center: [],
      loading: false,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getRestHomeSelectedFinancialAccount,
    formatValueOnKeyUp,
    formatValueNegativeOnKeyUp,
    handleBack() {
      this.$emit("cancel");
    },
    handleInputValue(value) {
      this.value = formatValueOnKeyUp(value);
    },
    async retrieve() {
      await this.financeConfigurationAccount();
      await this.financeConfigurationProfitCostCenter();
    },
    async financeConfigurationAccount() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/account-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_account = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationProfitCostCenter() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/profit-cost-center-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_profit_cost_center = data;
      } catch (error) {
        console.log(error);
      }
    },
    async create() {
      try {
        this.loading = true;

        const {
          origin_account_id,
          destination_account_id,
          date,
          description,
          value,
          finance_configuration_profit_cost_center_id,
        } = this;

        let params = {
          origin_account_id,
          destination_account_id,
          date,
          description,
          value,
          finance_configuration_profit_cost_center_id,
        };

        const response = await api.post(
          "/rest-home/financial/launch/transfer",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$emit("success");

          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
